/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable promise/no-promise-in-callback */
/* eslint-disable import/no-default-export */
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import i18n from 'i18next';

import { API_URL } from 'shared/config/apiUrl';
import { getCookie } from 'shared/lib/getCookie';
import { setAxiosHeader } from 'shared/lib/setAxiosHeader';
import { setCookie } from 'shared/lib/setCookie';

const apiInstance = axios.create({
	baseURL: API_URL,
	headers: {
		localization: getCookie(`CP_SAS_CULTURE`) ? getCookie(`CP_SAS_CULTURE`) : `en-EN`,
	},
});

apiInstance.interceptors.request.use(
	(config): InternalAxiosRequestConfig<unknown> => setAxiosHeader(config),
	error => Promise.reject(error),
);

apiInstance.interceptors.response.use(
	response => response,
	async (error: AxiosError) => {
		if (error.response?.status === 401) {
			const event = new CustomEvent(`OnCpAutorizationException`, { detail: `401 Error` });
			document.dispatchEvent(event);

			let attempts = 0;
			const maxAttempts = 2;
			const interval = 5000;

			const intervalId = setInterval(() => {
				attempts += 1;

				if (attempts >= maxAttempts) {
					clearInterval(intervalId);
					// window.location.reload();
				}
			}, interval);

			document.addEventListener(
				`OnCpSasTokenRefresh`,
				e => {
					(async () => {
						clearInterval(intervalId);
						// @ts-ignore
						const token = e.detail.cp_sas_token as string;
						setCookie(`CP_SAS_TOKEN`, token, new Date(Date.now() + 1000 * 60 * 60 * 24 * 30));
						const originalRequest = error.config;
						// @ts-ignore
						if (originalRequest && !originalRequest._retry) {
							// @ts-ignore
							originalRequest._retry = true;
							apiInstance.defaults.headers.Authorization = String(token);
							await apiInstance(originalRequest);
						}
					})();
				},
				{
					once: true,
				},
			);
		}

		if (axios.isAxiosError(error)) {
			return Promise.reject(error.response?.data ?? { ErrorText: i18n.t(`SERVER_ERROR`) });
		}

		return Promise.reject(error);
	},
);

export default apiInstance;
